import React from "react";
import AboutHero from "../sections/AboutHero";
import AboutServiceSection from "../sections/AboutServiceSection";
import Comment from "../sections/Comment";
import Reason from "../sections/Reason";
import ContactSection from "../sections/ContactSection";

const AboutUs = () => {
  return (
    <div>
      <AboutHero />
      <AboutServiceSection />
      <Comment />
      <Reason />
      <ContactSection />
    </div>
  );
};

export default AboutUs;
